module.exports = __webpack_public_path__ + "f632988f25f61968505f36afd04c0736.svg";